import { Button, styled } from '@mui/material';

const CircleButton = styled(Button)(({ theme, size }) => ({
  borderRadius: '50%',
  minWidth: 0,
  padding: size === 'small' ? theme.spacing(0.5) : theme.spacing(1),
}));

export default CircleButton;
